import * as React from 'react';
import { withRouter } from 'react-router-dom';
import GoBackBtn from '../shared/buttons/GoBackBtn';

const ReturnHomeHandler = ({ history }) => (
    <GoBackBtn label="Grįžti į darbus" onClick={history.goBack}/>
);

export default withRouter(ReturnHomeHandler);